<script>
  import Filter from "../Filter/Filter.svelte";
  import OrdersTable from "./OrdersTable.svelte";
  import InvoicesTable from "./InvoicesTable.svelte";
  import AbandonedOrdersTable from "./AbandonedOrdersTable.svelte";
  import { onDestroy, onMount } from "svelte";
  import { getOrderFilters, ORDER_FILTER_TYPE } from "../Filter/static";
  import BasicFilter from "./BasicFilter.svelte";
  import Searchbox from "../Common/Searchbox.svelte";
  import { AppCache } from "../stores";
  import {External, M} from "../external";

  export let options = null;

  let filterInstance;
  let filters = [];
  let instance = null;
  let tab = "orders";
  let disabledCrmProperties = [-1, -2, "utm_source", "utm_campaign", "utm_medium", "utm_content", "utm_term"];
  let tableDetails = {
    count: 0,
    label: ""
  };
  let activeFunnelId = options && options.funnel ? options.funnel : null;
  let activePeriod = {
    label: M.ALL_TIME_FILTER,
    id: "all",
    from: null,
    to: null
  };
  let searchPhrase = "";

  let orderFilters = getOrderFilters([
    ORDER_FILTER_TYPE.NAME,
    ORDER_FILTER_TYPE.EMAIL,
    //   ORDER_FILTER_TYPE.CREATED,
    ORDER_FILTER_TYPE.TOTAL,
    ORDER_FILTER_TYPE.PRODUCT,
    //   ORDER_FILTER_TYPE.FUNNEL,
    ORDER_FILTER_TYPE.STATUS,
    ORDER_FILTER_TYPE.PAID,
    ORDER_FILTER_TYPE.UTM_SOURCE,
    ORDER_FILTER_TYPE.UTM_CAMPAIGN,
    ORDER_FILTER_TYPE.UTM_MEDIUM,
    ORDER_FILTER_TYPE.UTM_CONTENT,
    ORDER_FILTER_TYPE.UTM_TERM
  ]);

  let onFilterChange = () => {
    setTimeout(() => {
      instance.reload();
    }, 1);
  };

  let changeTab = (newTab) => {
    tab = newTab;
  };

  let onTableLoaded = (event) => {
    let details = event.detail || {};
    tableDetails = {
      count: details.count || 0,
      label: details.label || ""
    };
  };

  let onBasicFilterChange = (event) => {
    activePeriod = event.detail.period;
    activeFunnelId = event.detail.funnel.id;
    onFilterChange();
  };

  let showMoreOptions = () => {
    const items = [
      {
        text: M.EXPORT_ORDERS,
        icon: "fa-cloud-download",
        tag: "export"
      }];

    if (window.hidePlatformFeesExport !== true) {
      items.push({
        text: M.EXPORT_PLATFORM_FEES,
        icon: "fa-usd",
        tag: "export-fees"
      });
    }

    if (tab === "orders") {
      items.push({
        text: M.ARCHIEVE_ORDERS,
        icon: "fa-trash",
        tag: "archive"
      });
    }
    if (tab === "archived") {
      items.push({
        text: M.UNARCHIVE_ORDERS,
        icon: "fa-inbox",
        tag: "unarchive"
      });
    }

    const moreTarget = External.$(event.target);
    External.Tools.showTooltipOptions(moreTarget, items, function (target, idx, text, tag) {
      switch (tag) {
        case "export":
          instance.startExport();
          break;
        case "export-fees":
          instance.startFeesExport();
          break;
        case "archive":
          instance.archive();
          break;
        case "unarchive":
          instance.unarchive();
          break;
      }
    });
  };

  let showSearch = (event) => {
    External.Tools.showFloatingPopup({
      markup: '<div class="col20 f-left bound-popup"></div>',
      width: 250,
      target: External.$(event.target),
      customClass: "floating-popup-list",
      action: {
        onShow: function (popup, ui) {
          let component = new Searchbox({
            target: ui.find(".bound-popup")[0],
            props: {
              term: searchPhrase,
              onSearch: function (term) {
                searchPhrase = term;
                onFilterChange();
              }
            }
          });
          popup.component = component;
        },
        onHide: function (popup) {
          if (popup.component) {
            popup.component.$destroy();
            popup.component = null;
          }
        }
      }
    });
  };

  let clearSearch = () => {
    searchPhrase = "";
    onFilterChange();
  };

  let loadSavedData = () => {
    if ($AppCache.orders) {
      let cached = $AppCache.orders;
      filters = cached.filters;
      tab = cached.tab;
      activeFunnelId = cached.activeFunnelId;
      activePeriod = cached.activePeriod;
      searchPhrase = cached.searchPhrase;

      AppCache.update((cache) => {
        cache.orders = null;
        return cache;
      });
    }
  };

  // calling this here to make sure it's called BEFORE the child components initialize
  loadSavedData();

  onMount(() => {});

  onDestroy(() => {
    if (instance.shouldSaveDataOnExit && instance.shouldSaveDataOnExit()) {
      instance.saveDataOnExit();

      AppCache.update((cache) => {
        let data = cache.orders || {};
        cache.orders = data;

        data.filters = filters;
        data.tab = tab;
        data.activeFunnelId = activeFunnelId;
        data.activePeriod = activePeriod;
        data.searchPhrase = searchPhrase;
        return cache;
      });
    } else {
      AppCache.update((cache) => {
        cache.orders = null;
        return cache;
      });
    }
  });
</script>

<div class="account-settings overflow store-products flex-1 horizontal-flex-table col20" style="font-family: 'Roboto';">
  <div class="top-background-wrapper narrow-top-background" style="padding-top:15px;">
    <div class="top-background filter-wrapper-outer">
      <Filter
        enableOR={false}
        bind:this={filterInstance}
        bind:filters
        enableSaveSegment={false}
        onChange={onFilterChange}
        disabledCrmProperties={disabledCrmProperties}
        customFilters={orderFilters} />
    </div>
    <div class="top-background">
      <div class="text-wrapper f-left col20 flex align-center space-between">
        <div class="flex-centered flex-col-mobile f-left">
          <div class="flex align-center justify-center">
            {#if tableDetails.label}
              <h2 class="crm-title f-left crm-title-bigger">{tableDetails.label}<i class="fa fa-circle" /></h2>
            {/if}
            <h2 class="crm-title f-left crm-title-bigger">{tableDetails.count} {M.ORDERS}</h2>
          </div>
          <BasicFilter on:change={(event) => onBasicFilterChange(event)} period={activePeriod} funnel={activeFunnelId} />
        </div>
        <div class="f-right flex-centered mobile-hidden">
          <div class="flex align-center search-inline-wrapper">
            {#if searchPhrase}
              <a on:click={clearSearch} class="remove-search-btn flex align-center mr-5 rounded-effect">
                <p class="f-left">{M.CLEAR}</p>
                <p class="material-icons-outlined ml-5 f-left">cancel</p>
              </a>
            {/if}
            <a on:click={(event) => showSearch(event)} class="circle-button blue rounded-effect flex align-center justify-center">
              <span class="material-icons-outlined">search</span>
            </a>
          </div>
          {#if tab !== "abandoned"}
          <a class="crm-option" on:click={showMoreOptions} style="margin-left: 10px; padding-right: 33px;">
            {M.MORE}
            <svg class="interface-icon o__standard" xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 16 16">
              <path d="M4 6l4 4 4-4H4z" />
            </svg>
          </a>
          {/if}
        </div>
      </div>
    </div>
  </div>
  <div class="content-wrapper horizontal-flex-table">
    <div class="sections-wrapper members-wrapper horizontal-flex-table">
      <div class="section-bg members-wrapper products-wrapper crm-table-outer">
        <ul class="upper-navigation upper-navigation-full mb-15 mt-15">
          <li><a class:active={tab === "orders"} on:click|preventDefault={() => changeTab("orders")}>{M.ORDERS}</a></li>
          <!--
          <li><a class:active={tab === "invoices"} on:click|preventDefault={() => changeTab("invoices")}>Invoices</a></li>-->
          <li><a class:active={tab === "archived"} on:click|preventDefault={() => changeTab("archived")}>{M.ARCHIVED_ORDERS}</a></li>
          <li><a class:active={tab === "abandoned"} on:click|preventDefault={() => changeTab("abandoned")}>{M.ABANDONED_CART}</a></li>
        </ul>

        {#if tab === "orders"}
          <OrdersTable bind:this={instance} filters={filters} period={activePeriod} funnel={activeFunnelId} search={searchPhrase} on:itemsloaded={onTableLoaded} />
        {:else if tab === "invoices"}
          <InvoicesTable bind:this={instance} on:itemsloaded={onTableLoaded} />
        {:else if tab === "abandoned"}
          <AbandonedOrdersTable bind:this={instance} filters={filters} period={activePeriod} funnel={activeFunnelId} search={searchPhrase} on:itemsloaded={onTableLoaded} />
        {:else if tab === "archived"}
          <OrdersTable
            bind:this={instance}
            filters={filters}
            period={activePeriod}
            funnel={activeFunnelId}
            search={searchPhrase}
            on:itemsloaded={onTableLoaded}
            showArchived={true} />
        {/if}
      </div>
    </div>
  </div>
</div>
